import React, { useState, useRef, useCallback } from 'react';
import { useClickOutside } from '@sdk/common/hooks/useClickOutside';

import LocationChecklistHeader from '@web/shifts/LocationChecklist/LocationChecklistHeader';
import LocationChecklistContent from '@web/shifts/LocationChecklist/LocationChecklistContent';
import {
  LocationChecklistContainer,
  ChecklistContentContainer,
  MenuContainer,
} from '@web/shifts/LocationChecklist/LocationChecklist.styles';

import { LocationChecklistFlag } from './types';

type Props = {
  userLocations: LocationChecklistFlag[];
  handleLocations: (id: ID, checkboxClicked: boolean) => void;
  clearIds: () => void;
};

const LocationChecklist: React.FC<React.PropsWithChildren<Props>> = ({
  userLocations,
  handleLocations,
  clearIds,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const checkedLocationsCount = userLocations.filter((location) => location.checked).length;
  const handleClickedOutside = useCallback(() => {
    setIsOpen(false);
  }, [setIsOpen]);

  const ref = useClickOutside<HTMLDivElement>(handleClickedOutside);

  return (
    <>
      <LocationChecklistContainer ref={ref}>
        <MenuContainer>
          <LocationChecklistHeader
            userLocations={userLocations}
            onClick={() => setIsOpen(!isOpen)}
            checkedLocationsCount={checkedLocationsCount}
          />
          <ChecklistContentContainer isActive={isOpen}>
            <LocationChecklistContent
              userLocations={userLocations}
              handleLocations={handleLocations}
              checkedLocationsCount={checkedLocationsCount}
              clearIds={clearIds}
            />
          </ChecklistContentContainer>
        </MenuContainer>
      </LocationChecklistContainer>
    </>
  );
};

export default LocationChecklist;
